module.exports = __webpack_public_path__ + "img/rarity5.196e395c.png";